import { getStore } from '../store';

export default function getWindowsTimeZoneIdFromIANAId(destTz: string): string {
    const { TimeZoneAlternateNames } = getStore();
    for (let timeZoneId of Object.keys(TimeZoneAlternateNames)) {
        if (
            TimeZoneAlternateNames[timeZoneId] &&
            TimeZoneAlternateNames[timeZoneId].includes(destTz)
        ) {
            return timeZoneId;
        }
    }

    return null;
}
